module.exports = __webpack_public_path__ + "d516e733b7f0eb8244c2ef38f5b9e3d1.svg";